import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'
import NowrapDiv from 'components/common/NowrapDiv'
import ResponsiveDiv from 'components/common/ResponsiveDiv'

const StepBadge = styled(Box)`
  width: 36px;
  height: 36px;
  border-radius: 12px 0 12px 0;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.typography.headlineSmall}
`

const StepCard = styled(Box)`
  background-color: #f6f6f6;
  border-radius: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const StepTitle = styled(NowrapDiv)`
  overflow-wrap: anywhere;
  word-break: break-word;
`

const ServiceFlowCard = ({ item, index }) => {
  return (
    <StepCard>
      <Box display="flex" alignItems="flex-start" gap={2}>
        <StepBadge>{index + 1}</StepBadge>
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          minWidth={0}
          pt={1.5}
          pr={2}
        >
          <Typography variant="titleLarge" color="primary.main" lineHeight={1}>
            <StepTitle $lines={2}>{item?.title}</StepTitle>
          </Typography>
        </Box>
      </Box>

      {!!item?.description && (
        <Box px="20px" pb="20px" pt="16px">
          <Typography
            variant="body1"
            color="text.minus2"
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              lineHeight: 1.5,
            }}
          >
            {item.description}
          </Typography>
        </Box>
      )}
    </StepCard>
  )
}

const VenderServiceFlows = ({ serviceFlows }) => {
  const safeServiceFlows = Array.isArray(serviceFlows)
    ? serviceFlows.filter((item) => item && typeof item === 'object')
    : []

  if (!safeServiceFlows.length) return null

  return (
    <Box mb={18}>
      <ResponsiveDiv>
        <Typography variant="h5" pb={6}>
          服務流程
        </Typography>
      </ResponsiveDiv>
      <Grid container spacing={6} alignItems="stretch">
        {safeServiceFlows.slice(0, 8).map((item, index) => (
          <Grid item xs={12} lg={3} key={index} display="flex">
            <Box width="100%">
              <ServiceFlowCard item={item} index={index} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default VenderServiceFlows
